import { Amplify } from 'aws-amplify'

import { env } from '@/lib/env'

let configured = false

/**
 * One-shot Amplify v6 configuration. Safe to call multiple times — subsequent
 * calls early-return. Reads env via the lazy validator so a developer hitting
 * the landing page locally without auth env populated doesn't crash on boot;
 * the first place this is invoked (AuthProvider) is also where missing env
 * is surfaced.
 *
 * Redirects are computed from `window.location.origin`, which matches what
 * we listed in the Cognito web App Client's callback/logout URL allow-list
 * (terraform: dev/terraform.tfvars web_callback_urls/web_logout_urls).
 */
export function configureAmplify() {
  if (configured) return
  const e = env()
  const origin = window.location.origin

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: e.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: e.VITE_COGNITO_APP_CLIENT_ID,
        loginWith: {
          oauth: {
            domain: e.VITE_COGNITO_DOMAIN,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [`${origin}/auth/callback`],
            redirectSignOut: [`${origin}/`],
            responseType: 'code',
          },
          email: true,
        },
      },
    },
  })

  configured = true
}
